// src/socket/useSocket.ts
import { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
function useSocket({
  namespace,
  token,
  serverUrl,
  enabled = true
}) {
  const [isConnected, setIsConnected] = useState(false);
  const [socket, setSocket] = useState(null);
  const socketRef = useRef(null);
  useEffect(() => {
    if (!enabled) return;
    const newSocket = io(`${serverUrl}${namespace}`, {
      auth: token ? { token } : {},
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1e3,
      reconnectionDelayMax: 5e3
    });
    socketRef.current = newSocket;
    setSocket(newSocket);
    const onConnect = () => setIsConnected(true);
    const onDisconnect = () => setIsConnected(false);
    const onError = (err) => {
      console.warn(`[Socket.IO ${namespace}] connect_error:`, err.message);
    };
    newSocket.on("connect", onConnect);
    newSocket.on("disconnect", onDisconnect);
    newSocket.on("connect_error", onError);
    return () => {
      newSocket.off("connect", onConnect);
      newSocket.off("disconnect", onDisconnect);
      newSocket.off("connect_error", onError);
      newSocket.disconnect();
      socketRef.current = null;
      setSocket(null);
      setIsConnected(false);
    };
  }, [namespace, token, serverUrl, enabled]);
  return { socket, isConnected };
}

// src/socket/useSocketEvent.ts
import { useEffect as useEffect2, useRef as useRef2 } from "react";
function useSocketEvent(socket, event, handler) {
  const handlerRef = useRef2(handler);
  handlerRef.current = handler;
  useEffect2(() => {
    if (!socket) return;
    const listener = (data) => {
      handlerRef.current(data);
    };
    socket.on(event, listener);
    return () => {
      socket.off(event, listener);
    };
  }, [socket, event]);
}
export {
  useSocket,
  useSocketEvent
};
//# sourceMappingURL=socket.mjs.map